import React from 'react';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';
import { onFormatPurchaseStatus } from '../../../../utils/constants/purchase-statuses';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import TableActions from '../../../../shared/table/table-actions';
import Button from '../../../../shared/button';
import Table from '../../../../shared/table';

const tableColumns = ['Purchase Id', 'Supplier', 'Status', 'Quantity', 'Shipping Cost', 'Price', 'Actions']

interface IPurchasesTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    onDownloadDetails: (id: string) => void;
    onSeePurchaseDetails: (id: string) => void;
    onEditPurchase: (partnerId: string) => void;
    onSeeMismatchDetails: (id: string) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onDeletePurchase: (id: string) => void;
}

const PurchasesTable = ({
    rows,
    paginationData,
    rowsLoading,
    onDownloadDetails,
    onEditPurchase,
    setPaginationState,
    onDeletePurchase,
    onSeeMismatchDetails,
    onSeePurchaseDetails
}: IPurchasesTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        const totalQuantity = (row?.items && row?.items?.length > 0) && row?.items?.reduce((accumulator: any, currentValue: any) => accumulator + (currentValue?.qty), 0)
                        const findCurrency = row?.currency
                        const value = onFormatPurchaseStatus(row?.status)?.name
                        const color = onFormatPurchaseStatus(row?.status)?.color
                        const text = onFormatPurchaseStatus(row?.status)?.text || 'text-black'
                        const item = color && <div className={`${color} border flex flex-row justify-center text-center px-1 min-w-[150px] ${text} text-sm py-1 font-medium !rounded-[6px]`}>{value}</div>
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.quoteId}</td>
                                <td className='px-6 py-4'>{row?.supplierInfo?.name || row?.supplierInfo?.username}</td>
                                <td className='px-6 py-4'>{item}</td>
                                <td className='px-6 py-4'>{totalQuantity || 0}</td>
                                <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(findCurrency || '').toLowerCase()}`]}{Number(row?.purchaseInfo?.shippingCosts || 0).toFixed(2)}</td>
                                <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(findCurrency || '').toLowerCase()}`]}{Number(row?.purchaseInfo?.grandTotal).toFixed(2)}</td>
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <div className='flex flex-row'>
                                        <div data-qa='purchase-details' onClick={() => (row?._id) && onSeePurchaseDetails(row?._id)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-2'} />
                                        </div>
                                        <TableActions>
                                            {row?.status === 'approved' &&
                                                <>
                                                    <div
                                                        onClick={() => onEditPurchase(row?._id)}
                                                        className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                        role='none'>
                                                        <Button
                                                            label={'Edit Purchase'}
                                                            dataQa={'edit-purchase'}
                                                            className={`btn-primary-text-underline !no-underline !font-normal !text-[#000] cursor-pointer`}
                                                        />
                                                    </div>
                                                </>
                                            }
                                            <div
                                                onClick={() => onDownloadDetails(row?._id)}
                                                className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                role='none'>
                                                <Button
                                                    label={'Download Details'}
                                                    dataQa={'download-purchase'}
                                                    className={`btn-primary-text-underline !no-underline !font-normal cursor-pointer`}
                                                />
                                            </div>
                                            {row?.status === 'approved' &&
                                                <>
                                                    <div
                                                        onClick={() => onDeletePurchase(row?._id)}
                                                        className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                        role='none'>
                                                        <Button
                                                            label={'Delete Purchase'}
                                                            dataQa={'delete-purchase'}
                                                            className={`btn-primary-text-underline !no-underline !font-normal !text-red-600 cursor-pointer`}
                                                        />
                                                    </div>
                                                </>
                                            }
                                            {row?.status === 'mismatch' &&
                                                <>
                                                    <div
                                                        onClick={() => onSeeMismatchDetails(row?.quoteId)}
                                                        className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                        role='none'>
                                                        <Button
                                                            label={'Mismatch Details'}
                                                            dataQa={'mismatch-purchase'}
                                                            className={`btn-primary-text-underline !no-underline !font-normal !text-[#00b67a] cursor-pointer`}
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </TableActions>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default PurchasesTable;